import { unProxy, proxy } from 'ajax-hook';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

/**
 * header 名称
 */
var ASGW_FONT_CONFUSE_HEADER_NAME = 'x-tt-zhal';
var fontFormatMap = {
    woff2: 'woff2',
    woff: 'woff',
    opentype: 'otf',
    // truetype: 'ttf',
};
var defaultFontFormats = ['woff2', 'woff', 'opentype'];

var originalFetch = typeof window === 'undefined' ? undefined : window.fetch;
var fetchHookCallbacks = [];
/**
 * 拦截 fetch 请求，获取 header
 * @param {HookCallback} callback 回调函数，参数为混淆 header 的值
 * @returns 注销函数，当回调函数为空时，解除拦截
 */
function hookFetch(callback) {
    if (originalFetch) {
        if (fetchHookCallbacks.length === 0) {
            window.fetch = function fetch() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var request = originalFetch.apply(window, args);
                request.then(function (res) {
                    var value = res.headers.get(ASGW_FONT_CONFUSE_HEADER_NAME);
                    if (typeof value === 'string')
                        fetchHookCallbacks.forEach(function (cb) { return cb(value); });
                });
                return request;
            };
        }
        fetchHookCallbacks.push(callback);
        var index_1 = fetchHookCallbacks.length - 1;
        return function () {
            fetchHookCallbacks.splice(index_1, 1);
            if (fetchHookCallbacks.length === 0)
                window.fetch = originalFetch;
        };
    }
    return function () { };
}

var xhrHookCallbacks = [];
function hookXhr(callback) {
    if (xhrHookCallbacks.length === 0) {
        proxy({
            onResponse: function (response, handler) {
                var value = response.headers[ASGW_FONT_CONFUSE_HEADER_NAME];
                if (typeof value === 'string')
                    xhrHookCallbacks.forEach(function (cb) { return cb(value); });
                handler.next(response);
            },
        });
    }
    xhrHookCallbacks.push(callback);
    var index = xhrHookCallbacks.length - 1;
    return function () {
        xhrHookCallbacks.splice(index, 1);
        if (xhrHookCallbacks.length === 0)
            unProxy();
    };
}

var FontMeta = /** @class */ (function () {
    function FontMeta(config) {
        var _this = this;
        if (config === void 0) { config = {}; }
        /** 域名列表 */
        this.domains = [];
        /** 本次混淆使用的文件名，不含后缀 */
        this.filename = '';
        /** 预留，后续可支持小字体直接返回 base64 */
        this.base64 = [];
        /** 目前可认为是和接口一一对应，这里是为了避免暴露 ID */
        this.fontKey = '';
        /** tos bucket 后缀，主要用于海外 */
        this.tosSuffix = '';
        Object.entries(config).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (key === 'f')
                _this.filename = value;
            else if (key === 'k')
                _this.fontKey = value;
            else if (key === 's')
                _this.tosSuffix = value;
            else if (key.match(/^d\d+$/))
                _this.domains.push(value);
            else if (key.match(/^b\d+$/))
                _this.base64.push(value);
        });
        if (!this.domains.length)
            this.domains = ['tosv.boe.byted.org'];
    }
    Object.defineProperty(FontMeta.prototype, "isValid", {
        /** 必要信息是否齐全。如果不全，通常代表字体混淆未开启 */
        get: function () {
            if (!this.fontKey)
                return false;
            if (!this.domains.length)
                return false;
            if (!this.filename && !this.base64.length)
                return false;
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FontMeta.prototype, "tosBucket", {
        get: function () {
            return "awesome-font" + this.tosSuffix;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 输出 @font-face 的内容
     *
     * font-family: xxx;
     * font-display: block;
     * src: url(xxx), url(xxx);
     */
    FontMeta.prototype.toFontFaceContent = function (_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.formats, formats = _c === void 0 ? defaultFontFormats : _c, _d = _b.weight, weight = _d === void 0 ? '400' : _d;
        if (!this.isValid)
            return '';
        var src = [];
        this.base64.forEach(function (base64String) { return src.push("url(\"" + base64String + "\")"); });
        var filename = weight === '400' ? this.filename : this.filename + "-" + weight;
        formats.forEach(function (format) {
            return _this.domains.forEach(function (domain) {
                return src.push("url(\"https://" + domain + "/obj/" + _this.tosBucket + "/c/" + filename + "." + fontFormatMap[format] + "\")" +
                    ("format(\"" + format + "\")"));
            });
        });
        return ("font-family:" + this.fontKey + ";" + "font-display:block;" + ("src:" + src.join(',') + ";") + ("font-weight:" + weight + ";"));
    };
    /**
     * 输出 @font-face
     *
     * ```css
     * @font-face xxx {
     *   font-family: xxx;
     *   font-display: block;
     *   src: url(xxx), url(xxx);
     * }
     * ```
     */
    FontMeta.prototype.toFontFaceString = function (_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.formats, formats = _c === void 0 ? defaultFontFormats : _c, _d = _b.weights, weights = _d === void 0 ? ['400', '500', '700'] : _d;
        if (!this.isValid)
            return '';
        return weights.map(function (weight) { return "@font-face{" + _this.toFontFaceContent({ formats: formats, weight: weight }) + "}"; }).join('');
    };
    /**
     * 输出 class 的内容
     *
     * font-family: DzAsSqy_gmwrBEF1, 'nunito_for_arco', 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
     */
    FontMeta.prototype.toClassContent = function (fallbackFonts) {
        if (fallbackFonts === void 0) { fallbackFonts = ''; }
        if (!this.isValid)
            return '';
        var fontFamily = this.fontKey;
        if (fallbackFonts)
            fontFamily += ',' + fallbackFonts;
        return "font-family:" + fontFamily + ";";
    };
    /**
     * 输出 class
     *
     * .font-DzAsSqy_gmwrBEF1 {
     *   font-family: DzAsSqy_gmwrBEF1, 'nunito_for_arco', 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
     * }
     */
    FontMeta.prototype.toClassString = function (fallbackFonts) {
        if (fallbackFonts === void 0) { fallbackFonts = ''; }
        if (!this.isValid)
            return '';
        return ".font-" + this.fontKey + "{" + this.toClassContent(fallbackFonts) + "}";
    };
    /**
     * 输出整个 style
     *
     * ```css
     * @font-face xxx {
     *   font-family: xxx;
     *   font-display: block;
     *   src: url(xxx), url(xxx);
     * }
     * .font-DzAsSqy_gmwrBEF1 {
     *   font-family: DzAsSqy_gmwrBEF1, 'nunito_for_arco', 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
     * }
     * ```
     */
    FontMeta.prototype.toStyleString = function (config) {
        if (!this.isValid)
            return '';
        return (this.toFontFaceString({ formats: config === null || config === void 0 ? void 0 : config.formats, weights: config === null || config === void 0 ? void 0 : config.fontWeights }) +
            this.toClassString(config === null || config === void 0 ? void 0 : config.fallbackFonts));
    };
    return FontMeta;
}());

function parseStringConfig(str) {
    if (!str || typeof str !== 'string')
        return new FontMeta();
    var result = {};
    var currentKey = '';
    var currentValue = '';
    var currentWord = '';
    var lastIsBackslash = false;
    for (var i = 0; i < str.length; i++) {
        var char = str[i];
        if (lastIsBackslash) {
            switch (char) {
                case '\\':
                case ';':
                case '=':
                    currentWord += char;
                    break;
                default:
                    currentWord += '\\';
                    currentWord += char;
                    break;
            }
            lastIsBackslash = false;
        }
        else if (char === '=') {
            currentKey = currentWord;
            currentWord = '';
            lastIsBackslash = false;
        }
        else if (char === ';') {
            currentValue = currentWord;
            currentWord = '';
            result[currentKey] = currentValue;
            currentKey = '';
            currentValue = '';
            lastIsBackslash = false;
        }
        else if (char === '\\') {
            lastIsBackslash = true;
        }
        else {
            currentWord += char;
            lastIsBackslash = false;
        }
    }
    if (currentKey)
        result[currentKey] = currentWord;
    return new FontMeta(result);
}
/**
 * 从 Response Header 中获取本次混淆的字体信息
 * @param {string|Record<string,unknown>|Headers} input 输入，可以为字符串、普通对象(如来自axios)、Headers对象(如来fetch)
 * @returns {FontMeta} 解析出的字体信息
 */
function parseConfig(input) {
    if (typeof input === 'string')
        return parseStringConfig(input);
    if (isHeaders(input)) {
        var value = input.get(ASGW_FONT_CONFUSE_HEADER_NAME);
        return parseStringConfig(value);
    }
    if (typeof input === 'object') {
        var value = input[ASGW_FONT_CONFUSE_HEADER_NAME];
        return parseStringConfig(value);
    }
    return new FontMeta();
}
function isHeaders(input) {
    return !!input && typeof input.get === 'function';
}

var StyleSheet = /** @class */ (function () {
    function StyleSheet() {
        this._id = 1;
        this._elements = {};
    }
    StyleSheet.prototype.destroy = function () {
        if (typeof document !== 'undefined') {
            Object.values(this._elements).forEach(function (element) {
                if (element)
                    document.head.removeChild(element);
            });
        }
        this._elements = {};
    };
    StyleSheet.prototype.insertRule = function (ruleStr) {
        var id = this._id++;
        if (typeof document !== 'undefined') {
            var element = document.createElement('style');
            element.dataset['font'] = id.toString();
            element.innerText = ruleStr;
            this._elements[id] = element;
            document.head.appendChild(element);
        }
        return id;
    };
    StyleSheet.prototype.deleteRule = function (id) {
        var element = this._elements[id];
        if (element && typeof document !== 'undefined') {
            document.head.removeChild(element);
            delete this._elements[id];
        }
    };
    return StyleSheet;
}());

var FontLoader = /** @class */ (function () {
    function FontLoader() {
        this._sheet = new StyleSheet();
        this._fontFaceMap = {};
        this._classNameMap = {};
        this.config = {
            hookFetch: true,
            hookXhr: false,
            debug: false,
            generateClassName: true,
            fontFormats: defaultFontFormats,
            fallbackFonts: '',
            fontWeights: ['400', '500', '700'],
        };
        this.parseHeaders = parseConfig;
    }
    FontLoader.prototype._insertFontFaceRule = function (fontName, rule) {
        if (this._fontFaceMap[fontName])
            this._sheet.deleteRule(this._fontFaceMap[fontName]);
        var id = this._sheet.insertRule(rule);
        this._fontFaceMap[fontName] = id;
    };
    FontLoader.prototype._insertClassNameRule = function (fontName, rule) {
        if (this._classNameMap[fontName])
            this._sheet.deleteRule(this._classNameMap[fontName]);
        var id = this._sheet.insertRule(rule);
        this._classNameMap[fontName] = id;
    };
    FontLoader.prototype.delete = function (fontName) {
        if (this._fontFaceMap[fontName]) {
            this._sheet.deleteRule(this._fontFaceMap[fontName]);
            delete this._fontFaceMap[fontName];
        }
    };
    FontLoader.prototype.auto = function (config) {
        var _this = this;
        this.config = __assign(__assign({}, this.config), config);
        if (this.config.hookFetch)
            this._stopHookFetch = hookFetch(function (v) {
                _this.addFromConfigString(v || '');
            });
        if (this.config.hookXhr)
            this._stopHookXhr = hookXhr(function (v) {
                _this.addFromConfigString(v || '');
            });
    };
    FontLoader.prototype.addFromConfigString = function (value) {
        var fontMeta = parseConfig(value);
        if (fontMeta) {
            this._insertFontFaceRule(fontMeta.fontKey, fontMeta.toFontFaceString({ formats: this.config.fontFormats, weights: this.config.fontWeights }));
            this._insertClassNameRule(fontMeta.fontKey, fontMeta.toClassString(this.config.fallbackFonts));
        }
    };
    return FontLoader;
}());
var instance = new FontLoader();

export default instance;
export { FontLoader, instance };
